import React from 'react';
import BreadcrumbsContainer from '../../../containers/BreadcrumbsContainer';
import Breadcrumbs from '../../../views/components/Breadcrumbs/Breadcrumbs';
import { routes } from 'config/routes';

const ComponentWithDecorator = (props: any) => {
  const { Component, client, isAdminUserAuth, ...matchProps } = props;
  const { match } = matchProps;
  const route = routes.find(r => r.path === match.path);
  const breadcrumbsInput = {
    routeName: (route && route.name) || '',
    url: match.url,
    tgrams_id: match.params.tgramsId,
    campaign_id: match.params.campaignId,
    product_id: match.params.productId
  };

  //console.log({ description: `ComponentWithDecorator` });

  return (
    <section className="site-content">
      <BreadcrumbsContainer breadcrumbsInput={breadcrumbsInput}>
        {({ breadcrumbs }) => {
          return breadcrumbs ? (
            <Breadcrumbs client={client} {...matchProps} breadcrumbs={breadcrumbs} />
          ) : null;
        }}
      </BreadcrumbsContainer>
      <main id="main" className="site-content__primary">
        <div
          className="container"
          style={{ display: 'flex', flexDirection: 'column', minHeight: '700px' }}
        >
          <Component {...matchProps} client={client} isAdminUserAuth={isAdminUserAuth}/>
        </div>
      </main>
    </section>
  );
};

export default ComponentWithDecorator;
